import React, { useState, useEffect } from 'react'
import { useTranslate } from '@helpers'
import { Tabs as AntTabs } from 'antd'
import Courses from './courses'
import Certificates from './certificates'
import { IUserInformation } from 'interfaces/user'
import { userProfileService } from '@services'
import { TableSkeleton } from 'modules/reusables/skeletons'
import { Wrapper } from './styled'

interface IProps {
  userId?: number
  userToken?: string
}

const { TabPane } = AntTabs

export const Tabs = ({ userId, userToken }: IProps) => {
  const { t } = useTranslate()
  const prefix = 'configuration.userProfile.tabs'
  const [activeTab, setActiveTab] = useState('1')
  const [loading, setLoading] = useState(false)
  const [userInformation, setUserInformation] = useState<IUserInformation>()

  useEffect(() => {
    getUserInformation()
  }, [])

  const getUserInformation = () => {
    if (userId) {
      setUserInformation({ id: userId })
    } else {
      if (userToken) {
        setLoading(true)
        userProfileService
          .getUserInformation(userToken)
          .then((response) => {
            setUserInformation(response)
          })
          .finally(() => {
            setLoading(false)
          })
      }
    }
  }

  return (
    <Wrapper>
      <AntTabs
        defaultActiveKey='1'
        activeKey={activeTab}
        onChange={(key: string) => setActiveTab(key)}
        animated={false}
      >
        <TabPane tab={t(`${prefix}.courses.header.title`)} key='1'>
          {loading ? (
            <TableSkeleton />
          ) : userInformation ? (
            <Courses userId={userInformation.id} />
          ) : null}
        </TabPane>
        <TabPane tab={t(`${prefix}.certificates.header.title`)} key='2'>
          {loading ? (
            <TableSkeleton />
          ) : userInformation ? (
            <Certificates userId={userInformation.id} />
          ) : null}
        </TabPane>
      </AntTabs>
    </Wrapper>
  )
}

export default Tabs
